module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d0705bad64076830636cdca02585a718.png";